// src/components/ParallaxCard.jsx
import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Slide-in parallax card.
 *
 * Props
 * ───────────────────────────────────────────────────────────
 * distance · how far off-screen to start (default "120vw")
 * start    · viewport offset that triggers motion (default "start 0.9")
 * end      · viewport offset where card is locked (default "start 0.1")
 *
 * Example:
 *   <ParallaxCard distance="140vw">…</ParallaxCard>
 */
export default function ParallaxCard({
  children,
  className = "",
  distance = "1200vw",
  start = "start 1.2",
  end = "start 0.8",
  ...rest
}) {
  const ref = useRef(null);

  /** 0 → top hits 90 % down the viewport
   *  1 → top reaches 10 % down the viewport   */
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [start, end],
  });

  /** Map full progress directly from distance → 0   */
  const x = useTransform(scrollYProgress, [0, 1], [distance, "0px"]);

  return (
    <motion.div ref={ref} style={{ x }} className={className} {...rest}>
      {children}
    </motion.div>
  );
}
